import { type Currency, formatAmount } from "@loot-os/api-contract";
import { CurrencyIcon } from "@loot-os/ui/components/currency-icon";
import { formatNumber } from "@loot-os/ui/lib/format";
import { cn } from "@loot-os/ui/lib/utils";

/**
 * The price / opens line under a box's name.
 *
 * Shoppers see the price and how often the box has been opened, never the
 * expected value: the odds table below already discloses every item, its
 * value and its chance, and the aggregate is not something a storefront
 * advertises. An unpriced draft (dashboard preview) shows "—" for the price.
 */
export function BoxSummaryLine({
  priceCents,
  openedCount,
  currency,
  className,
}: {
  /** Integer US cents. */
  priceCents: number;
  openedCount?: number;
  /** The environment's display currency; the amount and its icon come from it. */
  currency: Currency;
  className?: string;
}) {
  const priced = priceCents > 0;
  return (
    <p className={cn("text-sm text-muted-foreground", className)}>
      <CurrencyIcon currency={currency} /> {priced ? formatAmount(priceCents, currency) : "—"} per
      open
      {openedCount !== undefined && ` · ${formatNumber(openedCount)} opened`}
    </p>
  );
}
